module.exports = __webpack_public_path__ + "img/product3.871d64ed.png";